import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import goldSchemeService from "./goldSchemeService";

export const getAllGoldSchemes = createAsyncThunk(
  "goldScheme/get-all",
  async (_, thunkAPI) => {
    try {
      return await goldSchemeService.getGoldSchemes();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAGoldScheme = createAsyncThunk(
  "goldScheme/get-one",
  async (id, thunkAPI) => {
    try {
      return await goldSchemeService.getGoldScheme(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createGoldScheme = createAsyncThunk(
  "goldScheme/create",
  async (schemeData, thunkAPI) => {
    try {
      return await goldSchemeService.createGoldScheme(schemeData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAGoldScheme = createAsyncThunk(
  "goldScheme/update",
  async (data, thunkAPI) => {
    try {
      return await goldSchemeService.updateGoldScheme(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAGoldScheme = createAsyncThunk(
  "goldScheme/delete",
  async (id, thunkAPI) => {
    try {
      return await goldSchemeService.deleteGoldScheme(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSchemeNames = createAsyncThunk(
  "goldScheme/get-scheme-names",
  async (_, thunkAPI) => {
    try {
      return await goldSchemeService.getSchemeNames();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateSchemeNames = createAsyncThunk(
  "goldScheme/update-scheme-names",
  async (names, thunkAPI) => {
    try {
      return await goldSchemeService.updateSchemeNames(names);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("goldScheme/reset");

const initialState = {
  schemes: [],
  schemeNames: [],
  schemeDetail: null,
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const goldSchemeSlice = createSlice({
  name: "goldScheme",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllGoldSchemes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllGoldSchemes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.schemes = action.payload.data || [];
      })
      .addCase(getAllGoldSchemes.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAGoldScheme.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.schemeDetail = action.payload.data;
      })
      .addCase(createGoldScheme.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdScheme = action.payload;
      })
      .addCase(updateAGoldScheme.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedScheme = action.payload;
      })
      .addCase(deleteAGoldScheme.fulfilled, (state) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
      })
      .addCase(getSchemeNames.fulfilled, (state, action) => {
        state.schemeNames = action.payload.data || [];
      })
      .addCase(updateSchemeNames.fulfilled, (state, action) => {
        state.schemeNames = action.payload.data || [];
      })
      .addCase(resetState, () => initialState);
  },
});

export default goldSchemeSlice.reducer;
